<script setup lang="ts">

import {computed} from "vue";
import DefaultApplicationInfo from "@/utils/common/DefaultApplicationInfo.ts";
import Translator from "@/utils/common/Translator.ts";

defineProps<{ alwaysShow?: boolean }>()

const supportEndDate = computed(() => DefaultApplicationInfo.supportEndDate.value);
const isExpired = computed(() => (DefaultApplicationInfo.remainingSupportDays.value ?? 1) < 0);
const isExpiringSoon = computed(() => {
  const days = DefaultApplicationInfo.remainingSupportDays.value;
  const alertPeriod = DefaultApplicationInfo.customerSupportAlertPeriod.value;
  return days !== null && alertPeriod !== null && days >= 0 && days < alertPeriod;
});
const isLoaded = computed(() => DefaultApplicationInfo.remainingSupportDays.value !== null && supportEndDate.value !== null);

</script>

<template>
  <template v-if="isLoaded">
    <template v-if="isExpired">
      <q-chip square color="red-2" text-color="red-10" icon="gpp_bad"
              :label="Translator.translateId('supportExpiredOn') + ' ' + supportEndDate"/>
    </template>
    <template v-else-if="isExpiringSoon">
      <q-chip square color="orange-2" text-color="orange-10" icon="gpp_maybe"
              :label="Translator.translateId('supportWillExpireOn') + ' ' + supportEndDate + ' (' + DefaultApplicationInfo.getRemainingTime() + ')'"/>
    </template>
    <template v-else-if="alwaysShow">
      <span v-text="supportEndDate"/>
    </template>
  </template>
</template>

<style scoped>

</style>
